import client from "../client"

/**
 * PAYLOAD
 	taskList,
  taskComment,
  communityPostNew,
  communityPostComment,
  taskAlarm,
  newChallenge,
  newEvent,
	marketingInfo,
	taskCommentReply,
	communityPostCommentReply,
	challengeApplyResult,
	quizAlarm 
*/
export const updateUserPushConfig = async (payload) => {
  const body = Object.entries(payload).reduce((result, [k, v]) => {
    if (v !== undefined) result[k] = v
    return result
  }, {})

  const response = await client.put(`/users/push/config`, body)

  return response.data
}
